import Cookies from "js-cookie";
import { JWT_TOKEN, REFRESH_TOKEN, USER_INFO } from "../constants/auth";
import { UserInfo } from "../types/auth";
import { decodeUserInfo } from "./userInfoEncoding";

export function getCookieDomainSafe(): string {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (hostname === "localhost" || parts.length < 2) {
    return hostname;
  }

  return "." + parts.slice(-2).join("."); // e.g., .advancedcompliance.tech
}

export function saveUserInfo(data: string): void {
  localStorage.setItem(USER_INFO, data);
}

export function getUserInfo(): UserInfo | null {
  return decodeUserInfo<UserInfo>(localStorage.getItem(USER_INFO));
}

export function saveUserToken(token: string): void {
  Cookies.set(JWT_TOKEN, token, {
    domain: getCookieDomainSafe(),
    secure: true,
    sameSite: "Lax",
  });
}

export function saveRefreshToken(token: string, expiry?: string): void {
  Cookies.set(REFRESH_TOKEN, token, {
    domain: getCookieDomainSafe(),
    secure: true,
    sameSite: "Lax",
    expires: expiry ? new Date(expiry) : undefined,
  });
}

export function cookiesCleanup(): void {
  Cookies.remove(JWT_TOKEN, {
    domain: getCookieDomainSafe(),
    path: "/",
  });
  Cookies.remove(REFRESH_TOKEN, {
    domain: getCookieDomainSafe(),
    path: "/",
  });
  localStorage.removeItem(USER_INFO);
}
